import { render } from "./ListaEtapas.vue?vue&type=template&id=31b7f46c"
import script from "./ListaEtapas.vue?vue&type=script&lang=js"
export * from "./ListaEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__